export const SERVICES = [
    {
        slug: "artificial-turf-lawns",
        name: "Artificial Turf Lawns",
        short: "Hyper-realistic turf engineered for Idaho summers and winters. Soft underfoot, brutal on wear.",
        title: "Artificial Turf Lawn Installation in Idaho",
        headline: "Artificial turf lawns that stay perfect for 15+ years.",
        intro: "A flawless green lawn without mowing, watering, fertilizing, or weeding — engineered specifically for Idaho's hot, dry summers and freeze-thaw winters. Our PFAS-free turf looks real in July and stays perfect in January.",
        benefits: [
            "Save 50,000+ gallons of water per year on an average lawn",
            "No mowing, fertilizing, aerating, or reseeding — ever",
            "PFAS-free, lead-free, lab-tested fibers safe for kids and pets",
            "Drains 30+ inches of water per hour — no puddles or mud",
            "16-year manufacturer warranty plus our workmanship guarantee",
            "UV-stabilized blades resist fading in high-desert sun",
        ],
        process: [
            { step: "Free on-site measure", detail: "We walk your yard, check drainage and sun exposure, and give you a flat, no-surprise quote." },
            { step: "Excavation & base", detail: "We remove existing grass, grade the area, and compact a crushed-rock base built for Idaho freeze-thaw cycles." },
            { step: "Hand-laid installation", detail: "Turf is cut, seamed, and stretched by our in-house crew — invisible seams, crisp edges." },
            { step: "Infill & final groom", detail: "We power-broom infill into the fibers so blades stand tall, then walk the yard with you." },
        ],
        faq: [
            { q: "How much does an artificial turf lawn cost in Idaho?", a: "Most Treasure Valley lawns land between $9–$15 per square foot installed, depending on size, access, and turf grade. Every quote is flat and itemized — no surprises." },
            { q: "Will it look fake?", a: "No. We install multi-tone, thatch-layered turf with varied blade heights. Most neighbors won't know until you tell them — usually in January." },
            { q: "How long does installation take?", a: "Most residential lawns are completed in 1–3 days, including base work." },
        ],
    },
    {
        slug: "backyard-putting-greens",
        name: "Backyard Putting Greens",
        short: "Tournament-grade greens, custom contoured. Practice your short game without leaving home.",
        title: "Backyard Putting Green Installation in Idaho",
        headline: "A private putting green, steps from your back door.",
        intro: "Custom-designed, tournament-grade putting greens with real cups, true-roll surfaces, and contoured breaks — built for your yard and your game. From a single practice hole to full short-game complexes with fringe and chipping areas.",
        benefits: [
            "True ball roll, tuned to your preferred stimp speed",
            "Custom contours, breaks, and multiple cup locations",
            "Fringe, collars, and chipping aprons available",
            "Practice year-round — turf greens don't go dormant",
            "Adds genuine value and wow-factor to your property",
            "16-year manufacturer warranty on materials",
        ],
        process: [
            { step: "Design consult", detail: "We talk about your game, sketch the green's shape, breaks, and cup positions, and quote it flat." },
            { step: "Base & shaping", detail: "A compacted aggregate base is sculpted to the exact contours we designed together." },
            { step: "Green installation", detail: "Tournament-grade putting surface is laid, seamed, and cups are set to regulation depth." },
            { step: "Roll tuning", detail: "We test putts across every break and tune the surface until it rolls true." },
        ],
        faq: [
            { q: "How much does a backyard putting green cost in Idaho?", a: "Most custom greens run $15–$25 per square foot depending on size, contours, and fringe work. Smaller practice greens start lower — every quote is free and flat." },
            { q: "Can you add multiple holes and breaks?", a: "Yes — multiple cups, tiers, and contour breaks are our specialty. We design the green around how you like to practice." },
            { q: "Do the greens handle Idaho winters?", a: "Absolutely. The turf and base are engineered for freeze-thaw cycles and drain rapidly — your green is ready as soon as the snow melts." },
        ],
    },
    {
        slug: "pet-turf",
        name: "Pet & Play Turf",
        short: "Mud-free, drainable turf built for muddy paws, kids, trampolines, and everything in between.",
        title: "Pet Turf & Play Area Installation in Idaho",
        headline: "A mud-free yard your dogs and kids can't destroy.",
        intro: "Antimicrobial, rapid-drain turf systems built for the toughest customers: dogs, kids, and Idaho weather. No more muddy paws, worn paths, or dead spots — just a clean, soft, safe surface that rinses clean and stays green.",
        benefits: [
            "Antimicrobial fibers fight odors and bacteria",
            "Permeable backing drains 30+ inches per hour — urine washes through",
            "No more mud tracked into the house",
            "Soft, shock-absorbent surface safe for kids' play",
            "Dig-resistant installation with secured edges",
            "Zero fertilizers or pesticides — safe for every family member",
        ],
        process: [
            { step: "Yard & drainage check", detail: "We assess traffic patterns, drainage, and shade to spec the right turf and infill." },
            { step: "Base & drainage layer", detail: "A permeable compacted base keeps everything draining fast and smelling fresh." },
            { step: "Pet-grade installation", detail: "Heavy-duty turf with secured, dig-proof edges — installed by our own crew." },
            { step: "Antimicrobial infill", detail: "Odor-neutralizing infill is groomed in, and we show you the simple rinse routine." },
        ],
        faq: [
            { q: "Is artificial turf safe for dogs?", a: "Yes — our turf is PFAS-free, lead-free, and antimicrobial. It drains so fast that urine passes straight through, and a quick rinse keeps it fresh." },
            { q: "What about smells?", a: "The combination of antimicrobial fibers, rapid drainage, and odor-neutralizing infill handles it. Most owners rinse high-traffic spots weekly." },
            { q: "Can dogs dig through it?", a: "Our pet installations use reinforced edging and secured perimeters specifically to defeat diggers." },
        ],
    },
];

export const getService = (slug) => SERVICES.find((s) => s.slug === slug);
